import { Sneladvies } from '../translations-types';

const translations: Sneladvies = {
  title: 'Speciaal voor jou',
  newBlock: 'Nieuw blok',
  create: 'Blok toevoegen',
  edit: 'Speciaal voor jou bewerken',
  text: 'Tekst',
  textPlaceholder: 'Typ de tekst… (hyperlinks toegestaan)',
  saved: 'Opgeslagen',
  deleted: 'Verwijderd',
  deleteConfirm: 'Weet je het zeker? Het blok wordt verwijderd.',
  noBlocks: 'Nog geen blokken',
  panelTitle: 'Speciaal voor jou',
  panelHint: 'Voor in het klantportaal.',
  open: 'Speciaal voor jou selecteren',
  selectBlocks: 'Speciaal voor jou selecteren',
  publish: 'Versturen',
  published: 'Verstuurd en klant genotificeerd',
  noneSelected: 'Geen blokken geselecteerd',
  portalEmpty: 'Er is nog niets speciaals voor je klaargezet.',
  dutch: 'Nederlands',
  english: 'Engels',
  translateAuto: 'Vertaal automatisch (NL → EN)',
  enAutoHint: 'Leeg laten = automatisch vertaald bij opslaan. Handmatig aangepaste Engelse tekst blijft behouden.',
  translated: 'Engelse versie gegenereerd — controleer en sla op',
  noteLabel: 'Persoonlijke notitie',
  noteHint: 'Optioneel. Wordt bewaard en komt bovenaan in het portaal en in de mail aan de klant.',
  notePlaceholder: 'Schrijf een persoonlijke notitie voor de klant…',
  previousNotes: 'Eerdere notities',
  noteFrom: 'van',
};

export default translations;
